import React, { useEffect } from "react"
import { RouterProvider } from "react-router-dom"
import { Toaster } from "react-hot-toast"

import { globalToastOptions, version } from "@utils"
import { useTheme } from "./hooks"
import Router from "@src/router"

const App: React.FC = () => {
  useTheme()

  useEffect(() => {
    version()
  }, [])

  return (
    <div className="App">
      <RouterProvider router={Router} />
      <Toaster position="top-right" toastOptions={globalToastOptions} />
    </div>
  )
}

export default App
